import {IFormGroup} from '@core/api/data-access';
import {createActionGroup, emptyProps, props} from '@ngrx/store';

const getFormGroupEvents = {
	getFormGroupsList: emptyProps(),
	getFormGroupsListSuccess: props<{
		formGroups: IFormGroup[];
	}>(),
	getFormGroupsListFailure: props<{
		error: {error: string};
	}>(),
};

export const formGroupActions = createActionGroup({
	source: 'Form Group',
	events: {
		...getFormGroupEvents,
	},
});
